import { Images } from 'assets/images';
import {
  // Language,
  LoginButtons,
  Navigation,
} from './fragments';
import { UserName } from './fragments/UserName';
import {
  StyedBurgerContainer,
  StyledBurgerImage,
  StyledBurgerMenu,
  StyledContent,
  StyledImage,
  StyledUserNameContainer,
} from './styled';

export const BurgerMenu = ({ isAuth, routes, isOpen, setIsOpen }) => (
  <StyedBurgerContainer>
    {isOpen ? (
      isAuth() ? (
        <StyledUserNameContainer>
          <UserName />
          <StyledImage
            src={Images.rowUp}
            alt="row-up"
            onClick={() => setIsOpen(false)}
          />
        </StyledUserNameContainer>
      ) : (
        <StyledBurgerImage
          onClick={() => setIsOpen(false)}
          src={Images.burgerCloseIcon}
          alt="close"
        />
      )
    ) : isAuth() ? (
      <StyledUserNameContainer>
        <UserName />
        <StyledImage
          src={Images.rowDown}
          alt="row-down"
          onClick={() => setIsOpen(true)}
        />
      </StyledUserNameContainer>
    ) : (
      <StyledBurgerImage
        onClick={() => setIsOpen(true)}
        src={Images.burgerIcon}
        alt="burger-icon"
      />
    )}

    {isOpen ? (
      <StyledBurgerMenu>
        <StyledContent>
          <LoginButtons setIsOpen={setIsOpen} isAuth={isAuth} />
          <Navigation routes={routes} setIsOpen={setIsOpen} />
          {/* to do */}
          {/*<Language />*/}
        </StyledContent>
      </StyledBurgerMenu>
    ) : null}
  </StyedBurgerContainer>
);
